import styled from "styled-components";
import { breakpoints } from "../../globalStyles";
import { modalState } from "../../utils/constants";

const setMaxWidth = (props) => {
  switch (props.openingDirection) {
    case "fullWidth":
      return "100%";
    case "onRight":
      return "398px";
    case "onRightMenu":
      return "576px";
    case "fromBottom":
      return "100%";
    default:
      return "unset";
  }
};
const setAlignItems = (props) => {
  switch (props.modalName) {
    case "musicalTaste":
      return "flex-start";
    case "trackInfo":
    case "menu":
    case "toggleStream":
    case "feedback":
      return "unset";
    default:
      return "center";
  }
};

export const Background = styled.div`
  position: fixed;
  overflow: hidden;
  top: ${(props) =>
    props.openingDirection === "fromBottom" ? "20px" : "16px"};

  right: ${(props) => props.scrollbarWidth + 9 ?? 0}px;
  bottom: ${({ footerPlayerHeight }) => `${footerPlayerHeight + 13}px`};
  z-index: ${(props) => (props.isLast ? props.ZIndex : "100")};
  align-items: ${(props) =>
    props.openingDirection === "fullWidth" ? setAlignItems : "unset"};
  justify-items: ${(props) =>
    props.openingDirection === "fullWidth" ? "center" : "unset"};

  width: 100%;
  max-width: ${setMaxWidth};

  backdrop-filter: blur(16px);
  background-color: ${({ backgroundColor }) => backgroundColor};
  box-shadow: ${(props) =>
    props.modalName === modalState.CHAT ||
    props.modalName === modalState.TOGGLE_STREAM
      ? "0px 0px 0px 100vw rgba(37, 37, 37, 0.8)"
      : "none"};
  color: #ffffff;

  border: 1px solid #4c4c4c;
  border-radius: 24px;

  @media ${breakpoints.xs} {
    bottom: ${({ footerPlayerHeight }) => `${footerPlayerHeight + 5}px`};
    max-width: 95%;

    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const Head = styled.div`
  display: flex;
  align-self: center;
  width: 100%;
  justify-content: space-between;
  flex-direction: row-reverse;
  padding: 24px 24px 0px;

  position: ${({ modalName }) =>
    modalName === modalState.TRACK_INFO || modalName === modalState.RELEASE_TEXT
      ? "sticky"
      : undefined};

  top: ${({ modalName }) =>
    modalName === modalState.TRACK_INFO || modalName === modalState.RELEASE_TEXT
      ? "0"
      : undefined};

  z-index: ${({ modalName }) =>
    modalName === modalState.TRACK_INFO || modalName === modalState.RELEASE_TEXT
      ? "1"
      : undefined};

  @media (max-width: 390px) {
    padding: ${({ modalName }) => {
      if (modalName === modalState.RELEASE_TEXT) return "20px";
    }};
  }
`;

export const Title = styled.h3`
  display: flex;
  align-items: center;
  font-family: "Inter", sans-serif;
  font-weight: 700;
  line-height: 120%;
  font-size: 28px;

  color: rgba(255, 255, 255, 0.9);

  & svg {
    margin-right: 16px;
  }
  @media ${breakpoints.xs} {
    font-size: 20px;
    line-height: 120%;
  }
`;

export const ModalClose = styled.div`
  display: flex;
  align-items: center;

  font-family: "Vela Sans GX", sans-serif;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: 1px;
  background: transparent;
  font-size: 20px;
  text-transform: uppercase;
  cursor: pointer;
  transition: color 50ms ease-out;
  color: #ffffffe6;
  &:hover {
    color: #ed6c45;
  }
  & svg {
    margin-left: 20px;
  }
  & svg > path {
    transition: all 50ms ease-out;
  }
  &:hover svg > path {
    fill: #ed6c45;
  }
  @media ${breakpoints.sm} {
    font-size: 14px;
    & svg {
      margin-left: 12px;
    }
  }
`;
